import React from "react";
import InputField from "components/InputField/InputField";
import FileField from "components/InputField/FileField";
import RoleTagSelect from "containers/Input/DisciplineRoles";

const labels = {
  title: "Title",
};

const roles = {
  gp: "GP",
  gp_trainee: "GP Trainee",
  nurse: "Nurse",
  consultant: "Consultant",
  hospital_doctor: "NCHD (Hospital Doctor)",
  nurse_specialist: "Nurse Specialist/ANP",
  allied_healthcare_professional: "Allied Healthcare Professional",
  pharmacist: "Pharmacy",
  // midwifery: "Midwife",
};

const EditDisciplineForm = ({
  discipline = {},
  errors = {},
  onFieldChange,
  onSubmit,
  onRoleDisciplineChange,
  rolesOptions,
}) => {
  return (
    <div className="container_records">
      <div className="add_webinar new-webinar">
        <h3>Discipline #{discipline.id}</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            {["title"].map((e) => (
              <InputField
                className="col s12"
                label={labels[e]}
                field_name={e}
                onChange={onFieldChange}
                errors={errors[e]}
                autoComplete="new-password"
                value={discipline[e]}
              />
            ))}
            <div>
              <div className="col s12">
                <RoleTagSelect
                  style={{ marginTop: 10 }}
                  options={rolesOptions}
                  placeholder="Select roles"
                  value={discipline.discipline_type.map((role) => ({
                    value: role,
                    label: roles[role],
                  }))}
                  onChange={onRoleDisciplineChange}
                  multi={true}
                />
                <a
                  className={`${!discipline.discipline_type && "hide"}`}
                  href="javascript:void(0)"
                  onClick={() => {
                    onFieldChange({
                      target: { name: "discipline_type", value: [] },
                    });
                  }}
                >
                  Clear
                </a>
              </div>
            </div>
            <button
              onClick={onSubmit}
              className="button_classic"
              type="button"
              name="button"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

EditDisciplineForm.defaultProps = {};
export default EditDisciplineForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/EditDisciplineForm.jsx